import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Stack } from '@mui/material';

import { describeOverviewAnomaly } from '../model/emissionScreens';
import { isSafeGetRetry } from '../../../shared/api';
import { resolveUserFacingError } from '../../../shared/utils/actionFeedback';


export default function EmissionOverviewNotice({
  error,
  hasData,
  anomalies = [],
  onRetry,
}) {
  const { t } = useTranslation();
  const visibleAnomalies = hasData
    ? anomalies.map(describeOverviewAnomaly).filter(detail => detail.userVisible)
    : [];

  if (error) {
    return (
      <Alert
        severity="error"
        action={onRetry && isSafeGetRetry(error)
          ? <Button color="inherit" size="small" onClick={onRetry}>{t('common.retry')}</Button>
          : null}
      >
        {resolveUserFacingError(error, t('common.error.loadData'))}
      </Alert>
    );
  }

  if (visibleAnomalies.length === 0) return null;

  return (
    <Stack spacing={1}>
      {visibleAnomalies.map((detail) => {
        return (
          <Alert
            key={detail.raw}
            severity={detail.blocking ? 'error' : 'warning'}
          >
            {t(detail.labelKey, { target: detail.target, code: detail.raw })}
          </Alert>
        );
      })}
    </Stack>
  );
}
